const state = {
    isFooter: true,
    isHeader: true,
    app: null
}

const mutations = {
    SET_IS_FOOTER: (state, value) => {
        state.isFooter = value
    },
    SET_APP: (state, app) => {
        state.app = app
    },
    SET_HEADER: (state, value) => {
        state.isHeader = value
    },
}

const actions = {
    setFooter({commit}, value) {
        commit('SET_IS_FOOTER', value)
    },
    setHeader({commit}, value) {
        commit('SET_HEADER', value)
    },
    setApp({commit}, value) {
        commit('SET_APP', value)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}